import React from 'react'
import UserList from '../Components/PracticeFiles/UserList'

const Practice2 = () => {
  return (
    <>
    <div>Practice2</div>
    <UserList/>
    </>
  )
}

export default Practice2